import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerCompanyIdAtom, routerFieldIdAtom} from "./routerStore";
import {FieldResult} from "../types/domain/fieldResult";
import {getFieldResults} from "../services/resultsService";
import {activeDateAtom} from "./activeDateStore";
import {fieldHistoryDaysAtom} from "./fieldHistoryDaysStore";

/**
 * Returns results for active field for selected date
 */
export const activeFieldResultsAtom = atomWithRefresh<Promise<FieldResult[]>>(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const activeFieldId = get(routerFieldIdAtom);
    const activeDate = await get(activeDateAtom);
    const fieldHistoryDays = get(fieldHistoryDaysAtom);

    const results =
        activeCompanyId !== undefined && activeFieldId !== undefined && activeDate !== null
            ? await getFieldResults(activeCompanyId, activeFieldId, activeDate, fieldHistoryDays)
            : [];

    return results;
});

export const activeFieldResultsLoadable = loadable(activeFieldResultsAtom);
